import React, { lazy } from 'react';
import { CreateRoot } from '../../assets/js/react';
const SingIn = lazy(() => import("../../assets/js/react/components/login/login")
  .then(module => ({ default: module.SingIn })));

CreateRoot('login', <SingIn />);
